import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Nav, NavItem, NavLink, TabContent, TabPane, Table, Modal, ModalBody, ModalFooter, ModalHeader, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from 'axios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate } from 'react-icons/md'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import PosUserForm from '../components/PosUserForm'
import PosGlobalUser from '../components/PosGlobalUser'
import PosUserGroup from '../components/PosUserGroup'
import { getProfile, getProfile_v2 } from '../utils/dropdownlist'
import { BsPlusSquareFill } from 'react-icons/bs'
import { IconContext } from 'react-icons/lib'
import classnames from 'classnames'
import Select from 'react-select'
import { MDBDataTable } from 'mdbreact'

const tbColumn = [
      {
        label:'Product No.',
        field:'product_no',
        key:'product_no',
        sort:'asc',
        width:120
      },
      {
        label:'Name',
        field:'name',
        key:'name',
        sort:'asc',
        width:120
      },
      {
        label:'Category',
        field:'category',
        key:'category',
        sort:'asc',
        width:120
      },
      {
        label:'Type',
        field:'product_type',
        key:'product_type',
        sort:'asc',
        width:120
      },
      {
        label:'List Order',
        field:'list_order',
        key:'list_order',
        sort:'asc',
        width:120
      },

]

class PosUserProductPage extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      userModal: false,
      confirmModal: false,
      selectedData: '',
      selectedId: '',
      user_id: '',
      email: '',
      name: '',
      contact: '',
      role: '',
      profileId: '',
      isGlobal: true,
      isEdit: false,
      userId: '',
      userList: [],
      roleList: [],
      storeList: [],
      redirect: false,
      duplicateId: false,
      user_role: '',
      tabList: ['User', 'Group'],
      activeTab: '1',
      user_group: '',
      user_option: [],
      user_product :[],
      groupList:[],
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  toggle = (action, id) => () => {
    let obj = {}

    if (id !== undefined || id !== null) {
      obj = this.state.userList.find(e => e.profile_id === id)
    }

    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      userId: id != undefined || (id != null && action == 'EDIT') ? id : '',
      email: id != undefined || (id != null && action == 'EDIT') ? obj.email : '',
      name: id != undefined || (id != null && action == 'EDIT') ? obj.name : '',
      contact: id != undefined || (id != null && action == 'EDIT') ? obj.contact : '',
    })
  }

  //   toggleUser = id => () => {
  //     return this.setState({
  //       userModal: !this.state.userModal,
  //       userId: id,
  //     })
  //   }

  toggleConfirmModal = (name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
    })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
      userModal: false,
      confirmModal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getUserList()
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  selectHandler = () => e => {
    const { label, value } = e
    //console.log(value)
    this.setState({
      user_id: value,
    })
  }

  IDHandler = event => {
    const { name, value } = event.target

    let duplicateId = this.state.userList.some(x => x.user_id === value)

    this.setState({
      [name]: value,
      duplicateId: duplicateId,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const comp = StorageService.getSession('selected_org')
    if (!this.state.isEdit) {
      const data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',

        user_id: this.state.user_id,
        id: this.props.match.params.id,
        profile_id: this.state.profileId,
        created_by: user.email,
      }

      axios
        .post(url + ':3000/v1/user/group/add', data)
        .then(response => {
          const result = response.data
          if (result.error == true) {
            this.notificationSystem.addNotification({
              title: <MdClear />,
              message: result.message,
              level: 'error',
              position: 'br',
              autoDismiss: 4,
              dismissible: 'click',
            })
            return
          }

          this.notificationSystem.addNotification({
            title: <MdDone />,
            message: 'New user added successfully.',
            level: 'success',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          this.setState({ modal: false, user_id: '' })
          this.getUserList()
        })
        .catch(error => {
          if (error.response) {
            alert(error.response.data.message)
          }
          // else if (error.request) {
          //   console.log(error.request);
          // }
          else {
            alert('Error', error.message)
          }
        })
    } else {
      //   const data = {
      //     session_key: user.session_key,
      //     userId: this.state.userId,
      //     name: this.state.name,
      //     contact: this.state.contact,
      //   }
      //   axios
      //     .post(url + ':3000/v1/user/update-profile', data)
      //     .then(response => {
      //       const result = response.data
      //       if (result.error == true) {
      //         this.notificationSystem.addNotification({
      //           title: <MdClear />,
      //           message: result.message,
      //           level: 'error',
      //           position: 'br',
      //           autoDismiss: 4,
      //           dismissible: 'click',
      //         })
      //         return
      //       }
      //       this.notificationSystem.addNotification({
      //         title: <MdDone />,
      //         message: 'User details updated successfully.',
      //         level: 'success',
      //         position: 'br',
      //         autoDismiss: 4,
      //         dismissible: 'click',
      //       })
      //       this.setState({ modal: false })
      //       this.getUserList()
      //     })
      //     .catch(error => {
      //       alert(error)
      //     })
    }
  }

  delete = id => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      user_id: this.state.selectedId,
      id: this.props.match.params.id,
      remove_by: user.email,
    }

    axios
      .post(url + ':3000/v1/user/group/remove', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'User removed successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        this.getUserList()
      })
      .catch(error => {
        alert(error)
      })
  }

  getProductList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      user_id: this.props.match.params.id,
    }

    axios
      .post(url + ':3000/v1/user/products', data)
      .then(response => {
        const result = response.data
        //console.log(result.data);
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.setState({user_product: result.data});
        //this.setState({ user_group: result.data.user_group, userList: result.data.users })
      })
      .catch(error => {
        alert(error)
      })
  }

  getUserGroup = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      id: this.props.match.params.id,
    }

    axios
      .post(url + ':3000/v1/user/userwithgroup', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.setState({ user_id: result.data.user_id, groupList: result.data.groups })
      }).then(()=>{
        this.getUser();
      })
      .catch(error => {
        alert(error)
      })
  }

  getUser = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3000/v1/users', data)
      .then(response => {
        const result = response.data
        const groupUser = this.state.userList

        let UserOp = result.data.filter(x => !groupUser.some(y => y.user_id === x.user_id))

        console.log(UserOp)
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.setState({ user_option: UserOp })
      })
      .catch(error => {
        console.log(error)
        alert(error)
      })
  }

  componentDidMount() {
    //getProfile.call(this);
    //this.getProfile()
    window.scrollTo(0, 0);
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    this.setState({
      user_role: comp.Role,
    })
    this.getProductList();
    this.getUserGroup();
    //if (user.superUser) {
    if (comp.Role === 'Superuser' || comp.Role === 'Admin') {
      //this.getUserList()
      //this.getUser()
    }
    // } else {
    //   this.setState({
    //     redirect: true,
    //   });
    // }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getProfile() {
    getProfile_v2()
      .then(result => {
        if (this._isMounted) {
          if (result.error == true && result.message != 'Success') {
            alert(result.message)
            return
          }
          this.setState({
            roleList: result.data.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    const { activeTab, Role } = this.state

    let options = [
      ...this.state.user_option
        .reduce((r, o) => {
          let key = o.user_id
          let item = { value: o.user_id, label: o.name }
          return r.set(key, item)
        }, new Map())
        .values(),
    ]

    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    const data ={
      columns:tbColumn,
      rows:this.state.user_product
    }

    const styles = {
      container: {
        margin: '0 auto',
        padding: '20px',
        maxWidth: '800px',
        textAlign: 'center',
      },
      table: {
        width: '100%',
        borderCollapse: 'collapse',
        cursor: 'pointer',
      },
      th: {
        backgroundColor: '#f4f4f4',
        cursor: 'pointer',
        padding: '10px',
        border: '1px solid #ddd',
      },
      td: {
        padding: '10px',
        border: '1px solid #ddd',
      },
      theadTh: {
        backgroundColor: '#007bff',
        color: 'white',
      },
      searchInput: {
        marginBottom: '10px',
        padding: '8px',
        width: '100%',
        boxSizing: 'border-box',
      },
    };

    return (
      <Page
        className="Userpage"
        title="User Products"
        breadcrumbs={[
          { name: 'User', active: false, path: '/posuser' },
          { name: 'Products', active: true },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {(this.state.user_role === 'Superuser' || this.state.user_role === 'Admin') && (
          <>
            {/* <Row>
              <Col xl={12} lg={12} md={12}>
                <Card className="ps-card-display">
                  <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">User Group Information</CardHeader>
                  <CardBody>
                    <Row form>
                      <Col lg={4}>
                       
                        <p>{this.state.user_group}</p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row> */}
            <Row>
              <Col xs={12} lg={12} md={12}>
                <Card className="ps-card-display">
                  <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                    User Information
                  </CardHeader>
                  <CardBody>
                    <Row form>
                      <Col lg={4}>
                        <Label>User Name</Label>
                        <p>{this.state.user_id}</p>
                      </Col>
                      <Col lg={4}>
                        <Label>Number of Groups</Label>
                        <p>{this.state.groupList.length}</p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xl={12} lg={12} md={12}>
                <Card>
                  {/* <CardHeader>{this.state.user_group}</CardHeader> */}
                  <CardBody>
                    <div className="text-right mb-4">
                      <div className="ps-btn-group">
                        {/* <Button color="link" onClick={this.toggle('ADD', null)}>
                          <IconContext.Provider value={{ color: '#2a2c6b' }}>
                            <BsPlusSquareFill size={25} />
                          </IconContext.Provider>
                        </Button> */}
                      </div>
                    </div>

                    {this.state.user_product.length > 0 ? (
                      <MDBDataTable bordered small style={styles.table} data={data} searching={true} responsive displayEntries={false} paging={false} noBottomColumns={true} disableRetreatAfterSorting={true}/>
                    ): (
                      <Table responsive hover className="ps-table tb-col-8">
                        <thead>
                          <tr>
                            <th>Product No.</th>
                            <th>Name</th>
                            <th>Category</th>
                            <th>Type</th>
                            <th>List Order</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.productLoading ? (
                            <tr>
                              <td colSpan="7">
                                <div
                                  style={{
                                    minHeight: '100px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}>
                                  <Spinner animation="border" variant="primary" />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr>
                              <td colSpan="7">
                                <div className="ps-empty-data">
                                  <div className="empty-content">
                                    <MdCreate />
                                    <h4>No data to show</h4>
                                    {/* <span>Click the 'Create' button to add new product</span> */}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>)
                    }


                    {/* <Table responsive hover className="ps-table tb-col-5">
                      <thead>
                        <tr>
                          <th>Product No.</th>
                          <th>Name</th>
                          <th>Category</th>
                          <th>Type</th>
                          <th>List Order</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.userList.length < 1 && (
                          <tr>
                            <td colSpan="5">
                              <div className="ps-empty-data">
                                <div className="empty-content">
                                  <MdCreate />
                                  <h4>No data to show</h4>
                                  <span>Click the 'Create' button to add new user</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}

                        {this.state.userList &&
                          this.state.userList.length > 0 &&
                          this.state.userList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.product_no}</td>
                                <td>{item.name}</td>
                                <td>{item.category}</td>
                                <td>{item.product_type}</td>
                                <td>{item.list_order}</td>
                                
                              </tr>
                            )
                          })}
                      </tbody>
                    </Table> */}

                    <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
                      <Form onSubmit={this.handleSubmit} className="AuthForm">
                        <ModalHeader toggle={this.toggle()}>User</ModalHeader>
                        <ModalBody>
                          <Row>
                            <Col md={12}>
                              <FormGroup>
                                <Label for="role"></Label>
                                {/* <Input type="select" name="user_id" value={this.state.user_id} onChange={this.changeHandler} required>
                                  <option value=""></option>
                                  {this.state.user_option.length > 0 &&
                                    this.state.user_option.map((item, index) => {
                                      return (
                                        <option key={index} value={item.user_id}>
                                          {item.name}
                                        </option>
                                      )
                                    })}
                                </Input> */}
                                <Select options={options} name="user_id" onChange={this.selectHandler()} menuPosition={'fixed'} required />
                              </FormGroup>
                            </Col>
                          </Row>
                        </ModalBody>
                        <ModalFooter>
                          <Button className="theme-button theme-button-secondary" onClick={this.toggle()}>
                            Close
                          </Button>
                          <Button className="theme-button theme-button-primary" type="submit">
                            {this.state.isEdit ? 'Save' : 'Add'}
                          </Button>{' '}
                        </ModalFooter>
                      </Form>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}

        {/* <Modal isOpen={this.state.userModal} toggle={this.toggleUser()} className={this.props.className} centered>
          <PosUserForm history={this.props.history} onToggleModal={this.toggleUser} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal> */}

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} closeModal={this.closeModal} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete User</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to remove {this.state.selectedData} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </Page>
    )
  }
}
export default PosUserProductPage
